import React, { useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane, Col, Row } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../Pages/Constants';
import DeviceList from '../Components/Device/DeviceList.js';
import {FormattedMessage} from 'react-intl';


const Sensors = (props) => {
  	const [activeTab, setActiveTab] = useState('1');
  	const { classes } = props;

  	/**Component generating four tabs*/
  	return (
        <div className={classes.popup_background}>
            <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                <div className="management-menu-popup" style={{ display: "flex", flexDirection: "column" }}>
                    <Row className="justify-content-md-end" style={{ flexShrink: 0, paddingBottom: "12px" }}>
                		<Col style={{ fontWeight: "bold", fontSize: "clamp(1.25em, 4.5vw, 2.2em)" }}>
                			<center>
                                <FormattedMessage id="sensor.title" defaultMessage="Sensors" /> - {props.struct_info.struct_name}
                			</center>
                		</Col>
            		</Row>
                    <Row style={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
    	  			  <DeviceList structure_Id={props.structure_Id} accountInformation={props.accountInformation} role={props.accountInformation.role} reloadUserAndProfiles={props.reloadUserAndProfiles} device_list={props.device_list} setDeviceList={props.setDeviceList} subscription_info={props.subscription_info}/>
                    </Row>
                    <Row>
                        <center>
                            <button onClick={props.cancelPopup} className="btn btn-danger">
                                <FormattedMessage id="button.close" defaultMessage="Close" />                                           
                            </button>
                        </center>
                    </Row>
                </div>
            </div>
    	</div>
    );
};
export default withStyles(Constants.styles)(Sensors);